import { Theme } from '@material-ui/core';

const styles = (theme: Theme) => ({
  root: {
    '& .notifcationBadge': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.common.tan,
      padding: '0 5px',
      height: 15,
      borderRadius: 15,
      color: theme.palette.common.backgroundDark,
      fontSize: 12,
      fontWeight: '500',
      position: 'absolute',
      top: 6,
      right: 10,
      letterSpacing: '0',

      '&.notificationBadgePlus': {
        height: 18,
        right: 6,
        padding: '0 3px',
      },
    },
  },
});

export default styles;
